module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABABAMAAABYR2ztAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUxpcTc3Ny8vLzMzMzMzMzQ0NDIyMjIyMjIyMjIyMjIyMjMzMy8vLzMzM95MaGEAAAANdFJOUwAgIJ+gEMrggHDvQEBbsR6FAAAAo0lEQVR42u3VIQoCARSE4d+wwkajTSweQI9gEhY2KTaLYDEYBItVk7AInsC8R/AIJmVdlLmLJ3Ae9v0OMG/K8EiOMlbQlrXkJKtmLeuFApRBQtThwUzWhlYm45oDHSOn0fjTfGicIS3lFNxlfaLpVch7U8qLT9yikqmvUEB3NP7tQqPxp6RvAMlExrPHQNaWTFbNPpqeAlFCFb/mqawFHGTs8i9aFM6PhebLCAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/Group 90@2x.png
// module id = tcqP
// module chunks = 1